import $ from 'jquery';

const formId = 'bonus-faq-form';

let hasError = false;

function makeAlert(type) {
    const div = document.createElement('div');

    div.classList.add('alert', `alert-${type}`);

    return div;
}

function makeSuccessMessage(message) {
    const div = makeAlert('success');
    const text = document.createTextNode(message);

    div.append(text);

    return div;
}

function makeDangerMessage(message) {
    const div = makeAlert('danger');
    const text = document.createTextNode(message);

    div.append(text);

    return div;
}

/**
 *
 * @param {HTMLButtonElement} button
 */
function makeSpinnerButton(button) {
    const clonedButton = button.cloneNode();
    const spinner = document.createElement('span');

    spinner.classList.add('spinner-border', 'spinner-border-sm');
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-hidden', 'true');

    clonedButton.appendChild(spinner);
    clonedButton.disabled = true;
    clonedButton.type = "button";

    return clonedButton;
}

/**
 *
 * @param {Event} event
 */
function onSubmit(event) {
    event.preventDefault();

    /** @type {HTMLFormElement} */
    const form = event.currentTarget;
    const preservedButton = event.submitter || form.elements.submitter;
    const loadingButton = makeSpinnerButton(preservedButton);
    const url = form.action;
    const method = form.method;
    const data = new FormData(form);

    preservedButton.replaceWith(loadingButton);

    $.ajax({
        url,
        method,
        data,
        processData: false,
        contentType: false
    }).done((response) => {
        const successMessage = makeSuccessMessage(form.dataset.successMessage);

        Array.from(form.childNodes)
            .forEach((element) => element.parentElement.removeChild(element));
        form.appendChild(successMessage);
    })
        .fail((response) => {
            const errorMessage = makeDangerMessage(form.dataset.errorMessage);

            if (!hasError) {
                loadingButton.parentElement.parentElement.appendChild(errorMessage);
                hasError = true;
            }

            loadingButton.replaceWith(preservedButton);
        });
}

function bindListeners() {
    const form = document.getElementById(formId);

    if (!form)
        return;

    form.addEventListener('submit', onSubmit);
}

document.addEventListener('DOMContentLoaded', bindListeners, {once: true});
